import styles from './TravelFilterNav.module.scss'
import { Container, Col, Row } from 'react-bootstrap'
import React from 'react'
import { useTranslation } from 'next-i18next'
import TravelFilterForm from '@/components/models/travel/filter/TravelFilterForm'
import { useRouter } from 'next/router'
import TravelFilterInfoAndReset from '@/components/models/travel/filter/TravelFilterInfoAndReset'

const TravelFilterNav = () => {
  const { t } = useTranslation('common')
  const router = useRouter()

  const setUrlQueryString = (queryString: string) => {
    const checkString = `${router.pathname}${queryString ? '?' + queryString : ''}`
    if (router.asPath !== checkString) {
      router.push(
        {
          pathname: router.pathname,
          query: queryString,
        },
        undefined,
        { shallow: true }
      )
    }
  }

  return (
    <Container id="travel-filter-nav" className={styles.root}>
      <Row>
        <Col lg="3" className={`${styles.title}`}>
          {t('travelFilter.findTravel')}:
        </Col>
        <Col lg="6" className={styles.inputs}>
          <TravelFilterForm setUrlQueryString={setUrlQueryString} />
        </Col>
        <Col lg="3" className={styles.info}>
          <Col className={`align-self-end mt-2 mt-lg-0 ${styles.resultInfoWrap}`}>
            <TravelFilterInfoAndReset />
          </Col>
        </Col>
      </Row>
    </Container>
  )
}

export default TravelFilterNav
